import theme from "../../theme"

export const MODAL_CONTENT = {
  createWork: {
    name: 'createWork',
    type: 'action',
    title: '建立工作',
    subTitle: null,
    content: null,
    field: null,
    render: 'createWork',
    mainColor: theme.palette.primary.main,
    submitTxt: '建立',
    cancelTxt: '取消'
  },
  createClientWork: {
    name: 'createClientWork',
    type: 'action',
    title: '建立工作',
    subTitle: null,
    content: null,
    field: null,
    render: 'createClientWork',
    mainColor: theme.palette.primary.main,
    submitTxt: '建立',
    cancelTxt: '取消'
  },
  deleteWork: {
    name: 'deleteWork',
    type: 'simple',
    title: null,
    subTitle: null,
    content: '確定刪除工作？',
    field: null,
    render: 'default',
    mainColor: theme.palette.primary.main,
    submitTxt: '刪除',
    cancelTxt: '取消'
  },
  helpCenter: {
    name: 'helpCenter',
    type: 'action',
    title: '使用說明',
    subTitle: null,
    content: null,
    field: null,
    render: 'helpCenter',
    mainColor: theme.palette.primary.main,
    submitTxt: '確定',
    cancelTxt: null
  }
}